import Granim from 'granim'

import Util from '../util/Util'

export default class Background {
  static _totalSpeed = 60000
  static _baseGradients = [
    [ '#FFCC30', '#FF9A00' ],
    [ '#FF6B00', '#E20000' ],
    [ '#E20000', '#4D0E4F' ],
    [ '#A3B4D8', '#00AEEA' ],
    [ '#D4ACE2', '#A3A8D8' ],
    [ '#FFCC30', '#98528B' ],
  ]

  static _lerp (colorA, colorB, value) {
    if (value === 0) {
      return colorA
    }

    if (value === 1) {
      return colorB
    }

    const ah = Number(colorA.replace('#', '0x'))
    const ar = ah >> 16
    const ag = ah >> 8 & 0xff
    const ab = ah & 0xff
    const bh = Number(colorB.replace('#', '0x'))
    const br = bh >> 16
    const bg = bh >> 8 & 0xff
    const bb = bh & 0xff
    const rr = ar + value * (br - ar)
    const rg = ag + value * (bg - ag)
    const rb = ab + value * (bb - ab)

    return `#${((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1)}`
  }

  static _makeGradients (steps) {
    const gradients = []

    for (let i = 0; i < Background._baseGradients.length; i++) {
      const gradientA = Background._baseGradients[i]
      const gradientB = Background._baseGradients[i + 1] || Background._baseGradients[0]

      for (let j = 0; j < steps; j++) {
        const gradientAB = []
        const value = j / steps

        gradientAB[0] = Background._lerp(gradientA[0], gradientB[0], value)
        gradientAB[1] = Background._lerp(gradientA[1], gradientB[1], value)

        // console.log('%c  %c  %c  ', `background: ${gradientAB[0]}`, '', `background: ${gradientAB[1]}`)

        gradients.push(gradientAB)
      }
    }

    Background._gradients = gradients
    Background._speed = Background._totalSpeed / Background._gradients.length
  }

  static _cutToLength (index) {
    const { length } = Background._gradients

    return index >= length ? index - length : index
  }

  static _getCurrentGradients () {
    const index = Util._getNumber('currentColorIndex')

    return [
      ...Background._gradients.slice(index),
      ...Background._gradients.slice(0, index),
    ]
  }

  static _animation () {
    const granimInstance = new Granim({
      element: '#background-canv',
      direction: 'custom',
      customDirection: {
        x0: '0%',
        y0: '20%',
        x1: '60%',
        y1: '50%',
      },
      isPausedWhenNotInView: true,
      states: {
        'default-state': {
          transitionSpeed: Background._speed,
          gradients: Background._getCurrentGradients(),
        },
      },
    })

    granimInstance.play()
  }

  static init () {
    const canvas = document.getElementById('background-canv')

    if (localStorage.getItem('disableBackgroundRendering') === 'true') {
      if (canvas) {
        canvas.style.backgroundColor = 'silver'
      }

      return
    }

    Background._makeGradients(20)

    if (canvas) {
      canvas.addEventListener('granim:gradientChange', () => {
        const currentIndex = Background._cutToLength(Util._getNumber('currentColorIndex') + 1)

        localStorage.setItem('currentColorIndex', currentIndex)
      })

      Background._animation()
    }
  }
}
